import React from 'react'
import PropTypes from 'prop-types'

import KeyFeaturesWrapper from 'agency/digital_renderer/components/KeyFeaturesWrapper'
import styles from './styles.scss'

const KeyFeatures = (props) => {
  const { campaign } = props

  return (
    <KeyFeaturesWrapper
      campaign={campaign}
      render={({ features }) => (
        <div className={styles.root}>
          <h4>Key Features</h4>
          <ul className={styles.list}>
            {features.map(feature => (
              <li key={feature}>{feature}</li>
            ))}
          </ul>
        </div>
      )}
    />
  )
}

KeyFeatures.propTypes = {
  campaign: PropTypes.object.isRequired,
}

export default KeyFeatures
